import {useState} from 'react'
import {useIntl} from 'react-intl'
import BulkDropzone from '../add-special/components/BulkDropzone'
import {PRODUCTS_UPDATE_BULK_TEMPLATE, PRODUCTS_UPDATE_BULK_TEMPLATE_API} from './core/_requests'
import {isShopUser} from '../../common/stockScope'
import SharedData from '../../common/SharedData'
import EditSubmitButtonRow from './components/EditSubmitButtonRow'
import {isBarcodeOnlySheet} from './core/validateBulkSheet'

// Bulk-update card — restyled to match the Add Discount - Bulk design
// (.adb-stack / .adb-card / BulkDropzone) while keeping its own API
// implementation: the update template, the disable-active-offers option,
// the barcode-only guard, and EditSubmitButtonRow (the bulk-edit endpoint).
const EditBulkCard = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = SharedData()
  const [bulkFile, setBulkFile] = useState<any>({
    value: null,
    error: false,
  })
  const [disableActiveOffers, setDisableActiveOffers] = useState<boolean>(true)

  // Multi-supplier (B3): a barcode-only sheet has no product columns to
  // update — the bulk-edit endpoint rejects it. Catch it here with a clear message.
  const validateUpdateSheet = async (file: File): Promise<string | null> => {
    if (await isBarcodeOnlySheet(file)) {
      return formatMessage({id: 'BULK.ERROR.SINGLE_BARCODE_UPDATE'})
    }
    return null
  }

  return (
    <div className='adb-stack'>
      {/* Steps 1 & 2 — download template + upload bulk sheet */}
      <section className='adb-card'>
        <BulkDropzone
          id='sheet'
          hasError={bulkFile.error}
          setField={setBulkFile}
          // A shop account downloads the shop sheet (Barcode | Shelf quantity | Price, for its store);
          // everyone else keeps the long-standing Barcode | Quantity | Price file.
          templateUrl={isShopUser(currentUser) ? PRODUCTS_UPDATE_BULK_TEMPLATE_API : PRODUCTS_UPDATE_BULK_TEMPLATE}
          token={currentUser?.token}
          user={currentUser}
          validator={validateUpdateSheet}
        />
      </section>

      {/* Update option — disable the supplier's active offers as part of the update */}
      <section className='adb-card'>
        <div className='adb-card-inner'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              id='disableActiveOffers'
              checked={disableActiveOffers}
              onChange={(e) => setDisableActiveOffers(e.target.checked)}
            />
            <label className='form-check-label fw-semibold' htmlFor='disableActiveOffers'>
              {formatMessage({id: 'disable_active_offers'})}
            </label>
          </div>
          <div className='form-text'>{formatMessage({id: 'disable_active_offers_hint'})}</div>
        </div>
      </section>

      <EditSubmitButtonRow
        bulkFile={bulkFile}
        setBulkFile={setBulkFile}
        disableActiveOffers={disableActiveOffers}
      />
    </div>
  )
}

export default EditBulkCard
